import {
  Alias,
  ProductAliasesActionTypes,
  updateBatchAliasWorkstreamTagsAction,
} from '../types/productAliases'

export const GET_PRODUCT_ALIASES = '[command] productAliases/GET_PRODUCT_ALIASES'
export const POST_PRODUCT_ALIASES = '[command] productAliases/POST_PRODUCT_ALIASES'
export const GET_PRODUCT_ALIASES_SUCCESS = '[event] productAliases/GET_PRODUCT_ALIASES_SUCCESS'
export const GET_PRODUCT_ALIASES_ERROR = '[event] productAliases/GET_PRODUCT_ALIASES_ERROR'
export const POST_PRODUCT_ALIASES_SUCCESS = '[event] productAliases/POST_PRODUCT_ALIASES_SUCCESS'
export const POST_PRODUCT_ALIASES_ERROR = '[event] productAliases/POST_PRODUCT_ALIASES_ERROR'
export const SET_PRODUCT_ALIASES = '[document] productAliases/SET_PRODUCT_ALIASES'
export const SET_BATCH_PRODUCT_ALIASES = '[document] productAliases/SET_BATCH_PRODUCT_ALIASES'
export const UPDATE_PRODUCT_ALIASES = '[document] productAliases/UPDATE_PRODUCT_ALIASES'
export const UPDATE_BATCH_ALIAS_ASSIGNMENTS =
  '[document] productAliases/UPDATE_BATCH_ALIAS_ASSIGNMENTS'
export const SET_BATCH_ALIAS_ASSIGNMENTS_IS_CONFIRM =
  '[document] productAliases/SET_BATCH_ALIAS_ASSIGNMENTS_IS_CONFIRM'
export const SET_BATCH_ALIAS_ASSIGNMENTS_IS_IGNORED =
  '[document] productAliases/SET_BATCH_ALIAS_ASSIGNMENTS_IS_IGNORED'
export const DELETE_BATCH_ALIAS_ASSIGNMENTS =
  '[document] productAliases/DELETE_BATCH_ALIAS_ASSIGNMENTS'
export const UPDATE_BATCH_ALIAS_ASSIGNMENT_WORKSTREAM_TAGS =
  '[document] productAliases/UPDATE_BATCH_ALIAS_ASSIGNMENT_WORKSTREAM_TAGS'

// Commands
export const getProductAliases = (payload: { productIds: string[]; batchId?: string }) => ({
  type: GET_PRODUCT_ALIASES,
  payload,
})

export const postProductAliases = (payload: {
  id: string
  alias: string
  batchId?: string
  requestUuid?: string
}) => ({
  type: POST_PRODUCT_ALIASES,
  payload,
})

// Document
export const setProductAliases = (payload: { aliases: Alias[]; batchId?: string }) => ({
  type: SET_PRODUCT_ALIASES,
  payload,
})

export const setBatchProductAliases = (
  payload: {
    aliases: Alias[] | []
    batchId: string
  } | null
) => ({
  type: SET_BATCH_PRODUCT_ALIASES,
  payload,
})

export const updateProductAliases = (
  payload: Extract<ProductAliasesActionTypes, { type: typeof UPDATE_PRODUCT_ALIASES }>['payload']
): Extract<ProductAliasesActionTypes, { type: typeof UPDATE_PRODUCT_ALIASES }> => ({
  type: UPDATE_PRODUCT_ALIASES,
  payload,
})

export const updateBatchAliasAssignments = (
  payload: {
    batchId: string
    batchSelectedProduct: {}
    batchSelectedProductPhotos: {}[]
    batchSelectedProductAliases: string[]
    isConfirmed: boolean
  } | null
) => ({
  type: UPDATE_BATCH_ALIAS_ASSIGNMENTS,
  payload,
})

export const setBatchAliasAssignmentsIsConfirm = (payload: {
  batchId: string
  isConfirmed: boolean
}) => ({
  type: SET_BATCH_ALIAS_ASSIGNMENTS_IS_CONFIRM,
  payload,
})

export const setBatchAliasAssignmentsIsIgnored = (payload: {
  batchId: string
  isIgnored: boolean
}) => ({
  type: SET_BATCH_ALIAS_ASSIGNMENTS_IS_IGNORED,
  payload,
})

export const deleteBatchAliasAssignments = (payload: { batchId: string }) => ({
  type: DELETE_BATCH_ALIAS_ASSIGNMENTS,
  payload,
})

export const updateBatchAliasWorkstreamTags = (
  payload: updateBatchAliasWorkstreamTagsAction['payload']
): updateBatchAliasWorkstreamTagsAction => ({
  type: UPDATE_BATCH_ALIAS_ASSIGNMENT_WORKSTREAM_TAGS,
  payload,
})
